/* eslint-disable no-nested-ternary */
import Image from '../Image';
import SwiperBasic from '../Swiper/SwiperBasic';
import { Tit } from '../Titles';
import { anniversaryStoryVo } from '@/__generated__/FrontApi';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Autoplay, Navigation, Scrollbar } from 'swiper';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation, Scrollbar, A11y, Autoplay]);

interface TogeterProps {
  campaigns: anniversaryStoryVo[];
  img?: boolean;
  overflowHidden?: boolean;
  autoplay?: boolean;
}

const CardLayout = styled.div`
  ${Tit} {
    margin-top: 32px;
    line-height: 1.6;
    small {
      font-size: 16px;
      display: block;
      margin-top: 16px;
      font-weight: 400;
    }
  }
`;
const CardImage = styled.div`
  overflow: hidden;
  position: relative;

  .img-box {
    width: 100%;
    padding-top: 62%;
  }

  .card-img {
    max-width: 100%;
    width: 100%;
  }
`;

const SwiperCustom = styled(SwiperBasic)`
  overflow: hidden;
  padding: 0;
  .swiper-container {
    padding: 70px 20px 105px;

    ${breakpoint(`tablet`)} {
      padding: 44px 20px;
    }

    .swiper-scrollbar::before {
      opacity: 1;
      background: #fff;
    }
    .swiper-button-next,
    .swiper-button-prev {
      transform: translateX(35px);
    }

    .swiper-slide {
      overflow: hidden;
      margin-right: 40px;
      border-radius: 0 0 40px 0;

      &:last-of-type {
        margin-right: 0;
      }

      ${breakpoint(`mobile`)} {
        border-radius: 0 0 20px 0;
        margin-right: 0;
      }
    }
  }
`;

const TogetherCard: FC<TogeterProps> = ({ campaigns, img, ...props }) => (
  <SwiperCustom {...props}>
    <Swiper
      slidesPerView="auto"
      navigation
      scrollbar={{ draggable: true }}
      autoplay={props.autoplay}
      onSwiper={(swiper) => {
        setTimeout(() => {
          swiper.update(); // ------> this solution
        }, 3000);
      }}
    >
      {campaigns.map((items: anniversaryStoryVo) => (
        <SwiperSlide key={items.indexNumber}>
          <Link
            to={items.linkUrl || '#'}
            onClick={(e) => {
              if (!items.linkUrl) {
                e.preventDefault();
              }
            }}
          >
            <CardLayout className="CardLayout">
              <CardImage className="img-wrap">
                {img ? (
                  <Image
                    className="card-img"
                    pcSrc={items.imgAttGrpNoPc}
                    mobileSrc={items.imgAttGrpNoMob}
                  />
                ) : (
                  <div
                    className="img-box"
                    css={`
                      background-image: url(${items.imgAttGrpNoPc});
                    `}
                  />
                )}
              </CardImage>
            </CardLayout>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  </SwiperCustom>
);
export default TogetherCard;
